import { loadStripe, type Stripe } from '@stripe/stripe-js';

// Memoized so repeated calls (e.g. re-opening CardOnFileModal) reuse the same
// underlying Stripe.js instance instead of re-injecting the script each time.
let promise: Promise<Stripe | null> | null = null;
export function getStripe(): Promise<Stripe | null> {
  if (!promise) promise = loadStripe(import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY ?? '');
  return promise;
}
